var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.46,
    height: 16.409,
    viewBox: "0 0 18.46 16.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-signature",
    "data-name": "Icon awesome-file-signature",
    d: "M6.992,13.593a.355.355,0,0,0-.326-.209.35.35,0,0,0-.321.2l-.246.492a.513.513,0,0,1-.945-.067L4.615,12.39l-.34,1.022a1.384,1.384,0,0,1-1.314.946h-.4a.513.513,0,1,1,0-1.026h.4a.359.359,0,0,0,.341-.245l.583-1.751a.769.769,0,0,1,1.46,0L5.79,12.67a1.438,1.438,0,0,1,2.115.454.364.364,0,0,0,.3.2V10.693l4.1-4.073V5.128H7.948a.771.771,0,0,1-.769-.769V0H.769A.767.767,0,0,0,0,.769V15.64a.767.767,0,0,0,.769.769H11.538a.767.767,0,0,0,.769-.769V14.358l-4.1,0A1.376,1.376,0,0,1,6.992,13.593Zm5.315-9.686a.767.767,0,0,0-.224-.542L8.945.224A.769.769,0,0,0,8.4,0H8.2V4.1h4.1ZM9.23,11.12v2.213h2.211l5.182-5.217L14.447,5.94,9.23,11.12Zm8.991-5.757L17.2,4.341a.816.816,0,0,0-1.154,0l-.873.873L17.348,7.39l.873-.873A.816.816,0,0,0,18.221,5.363Z",
    fill: "#337dff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSignature);
export default __webpack_public_path__ + "static/media/file-signature.e84c4f648d47108844834257ff92ffed.svg";
export { ForwardRef as ReactComponent };